import _axios from "../../..";
import { Company, Sdg } from "../../../../types";
import { RemoveCompanyProfileProps } from "../tyoes";

const SdgService = {
  getAll: async (): Promise<Sdg[]> => (await _axios.get("sdg")).data,

  create: async (body: string[], company_id: Company["id"]): Promise<void> =>
    (await _axios.post(`sdg/${company_id}`, { sdg_ids: body })).data,

  remove: async ({
    id,
    company_id,
    company_profile_id,
  }: RemoveCompanyProfileProps): Promise<void> =>
    await _axios.delete(`sdg/relation${id ? `/${id}` : ""}`, {
      data: { company_id, company_profile_id },
    }),
};

export default SdgService;
